/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import TokenModal from "./TokenDialog";
import SlippageSettings from "./SlippageSettings";
import { IoSettings } from "react-icons/io5";
import {
    getErc20Contract,
    getFactoryContract,
    getRouterContract,
    getWalletBalanceContract,
} from "../contexts/thirdWebClient";
import { allowance, approve, balanceOf } from "thirdweb/extensions/erc20";
import { routerAddress, WETHAddress } from "../contexts/config";
import {
    useActiveAccount,
    useActiveWalletChain,
} from "thirdweb/react";
import {
    prepareContractCall,
    readContract,
    sendTransaction as sendTx,
} from "thirdweb";
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { getPathAddress } from "../services/apiService";


const Swap = () => {
    const [open, setOpen] = useState(false);
    const [openBuy, setOpenBuy] = useState(false);
    const [selected, setSelected] = useState(null);
    const [selectedBuy, setSelectedBuy] = useState(null);
    const [loading, setLoading] = useState(false);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [slippage, setSlippage] = useState(() => {
        const saved = localStorage.getItem("dexora_slippage");
        return saved ? parseFloat(saved) : 1;
    });

    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();
    useEffect(() => {
        if (add && add.address) {
            console.log("%c Line:41 🍅 add", "color:#7f2b82", add);
            setAddress(add.address);
        } else {
            // Wallet disconnected - clear all data
            setAddress("");
            setToken1Details({});
            setToken2Details({});
            setToken1value(0);
            setToken2value(0);
            setToken1valueDirect(0);
            setToken2valueDirect(0);
            setInsufficientBalance(false);
            setBalanceLoading(false);
        }
    }, [add, chain]); // eslint-disable-line react-hooks/exhaustive-deps

    const [token1Details, setToken1Details] = useState({});
    const [token2Details, setToken2Details] = useState({});

    const [token1value, setToken1value] = useState(0);
    const [token1valueDirect, setToken1valueDirect] = useState(0);
    const [token2value, setToken2value] = useState(0);
    const [token2valueDirect, setToken2valueDirect] = useState(0);
    const [swapType, setSwapType] = useState(1);
    const [insufficientBalance, setInsufficientBalance] = useState(false);
console.log("token2value",token1value,token2value)
    useEffect(() => {
        const getData = async () => {
            setBalanceLoading(true);
            if (
                selected &&
                selected !== "" &&
                selected?.address &&
                address &&
                selected?.address !=
                "0x0000000000000000000000000000000000000000"
            ) {
                let tokenDetails = selected;
                const contract = getErc20Contract(selected.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                tokenDetails.approvedBalance = Number(approvedAmount) * 1;
                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                tokenDetails.balance =
                    Number(
                        ethers.formatUnits(
                            tokenBalance,
                            tokenDetails?.decimals,
                        ),
                    ) * 1;
                setToken1Details(tokenDetails);
            }
            if (
                selected &&
                selected !== "" &&
                selected?.address ==
                "0x0000000000000000000000000000000000000000"
            ) {
                let tokenDetails = selected;

                tokenDetails.approvedBalance = Number(100000000000) * 1;
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );

                tokenDetails.balance =
                    Number(ethers.formatUnits(tokenBalance, 18)) * 1;

                setToken1Details(tokenDetails);
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address &&
                selectedBuy?.address !=
                "0x0000000000000000000000000000000000000000" &&
                address
            ) {
                let tokenDetails = selectedBuy;
                const contract = getErc20Contract(selectedBuy.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                tokenDetails.approvedBalance = Number(approvedAmount) * 1;

                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                tokenDetails.balance =
                    Number(
                        ethers.formatUnits(
                            tokenBalance,
                            tokenDetails?.decimals,
                        ),
                    ) * 1;
                setToken2Details(tokenDetails);
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address ==
                "0x0000000000000000000000000000000000000000"
            ) {
                let tokenDetails = selectedBuy;

                tokenDetails.approvedBalance = Number(100000000000) * 1;
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );
                tokenDetails.balance =
                    Number(ethers.formatUnits(tokenBalance, 18)) * 1;
                setToken2Details(tokenDetails);
            }
            setBalanceLoading(false);
        };
        getData();
    }, [selected, selectedBuy, loading]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (token1Details.address && token2Details.address) {
            fetchLpDetails();
        }
    }, [token1Details.address, token2Details.address]); // eslint-disable-line react-hooks/exhaustive-deps

    // Reset insufficient balance when tokens change
    useEffect(() => {
        setInsufficientBalance(false);
        setToken1value(0);
        setToken2value(0);
    }, [selected, selectedBuy]);

    // Calculate minimum output with slippage
    const calculateMinOutput = (expectedAmount, decimals) => {
        try {
            const slippageMultiplier = (100 - slippage) / 100;
            const minAmount = parseFloat(expectedAmount) * slippageMultiplier;
            return ethers.parseUnits(minAmount.toFixed(decimals), decimals);
        } catch (error) {
            console.log("Error calculating min output:", error);
            return "1"; // Fallback to 1
        }
    };

    // eslint-disable-next-line no-unused-vars
    const approveTokenFun = async (tokenAddress) => {
        try {
            setLoading(true);
            // const { mutate: sendTransaction } = useSendTransaction();
            const contract = getErc20Contract(tokenAddress, chain);
            const transaction = approve({
                contract,
                spender: routerAddress,
                amount: 1000,
            });
            console.log(
                "%c Line:117 🍢 transaction",
                "color:#ed9ec7",
                transaction,
                add,
            );
            const tx = await sendTx({ transaction, account: add });
            console.log("%c Line:118 🥔 tx", "color:#93c0a4", tx);
            toast.success("Token approved");
            setLoading(false);
        } catch (error) {
            toast.error(error?.message);
            setLoading(false);

            console.log("%c Line:111 🍫 error", "color:#ed9ec7", error);
        }
    };

    const [price, setPrice] = useState(0);
    const [lpAddress, setLpAddress] = useState(false);
    const [token1LpBalance, setToken1LpBalance] = useState(0);
    const [token2LpBalance, setToken2LpBalance] = useState(0);

    const fetchLpDetails = async () => {
        try {
            const routerContract = await getRouterContract(chain);
            const factoryContract = await getFactoryContract(chain);

            let pairAddress = await readContract({
                contract: factoryContract,
                method: "function getPair(address, address) view returns (address)",
                params: [
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                ],
            });

            if (pairAddress != "0x0000000000000000000000000000000000000000") {
                // setLpAddress(true);
                setLpAddress([token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token1Details?.address,
                token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token2Details?.address]);

                const Token0contract = getErc20Contract(
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    chain,
                );
                let tokenOUserBalance = await balanceOf({
                    contract: Token0contract,
                    address: pairAddress,
                });
                setToken1LpBalance(tokenOUserBalance);

                const Token1contract = getErc20Contract(
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                    chain,
                );

                let token1UserBalance = await balanceOf({
                    contract: Token1contract,
                    address: pairAddress,
                });
                setToken2LpBalance(token1UserBalance);

                let tokenPrice = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits("1", selected?.decimals),
                        tokenOUserBalance,
                        token1UserBalance,
                    ],
                });

                setPrice(
                    Number(
                        ethers.formatUnits(tokenPrice, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            } else {
                const getPath = await getPathAddress(token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token1Details?.address,
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address)

                console.log("%c Line:277 🥃 getPath", "color:#f5ce50", getPath);

                if (getPath.data) {
                    let pairAddress = await readContract({
                        contract: routerContract,
                        method: "function getAmountsOut(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                        params: [ethers.parseUnits("1", selected?.decimals), getPath.data]
                    });

                    setPrice(
                        Number(
                            ethers.formatUnits(pairAddress[pairAddress.length - 1], selectedBuy?.decimals),
                        ).toFixed(5),
                    );


                    setLpAddress(getPath.data);
                } else {
                    setLpAddress(false)
                }
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPriceDetails = async (value) => {
        try {
            // If value is empty or 0, don't proceed with fetch
            const numValue = parseFloat(value);
            if (!value || value === '' || isNaN(numValue) || numValue === 0 || numValue <= 0) {
                return;
            }

            // Check if value exceeds balance
            if (!isNaN(numValue) && numValue > 0 && token1Details?.balance !== undefined) {
                setInsufficientBalance(numValue > token1Details.balance);
            } else {
                setInsufficientBalance(false);
            }

            const routerContract = await getRouterContract(chain);
            if (lpAddress && lpAddress.length > 1) {

                let pairAddress = await readContract({
                    contract: routerContract,
                    method: "function getAmountsOut(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                    params: [ethers.parseUnits(value, selected?.decimals), lpAddress]
                });
                setToken2value(
                    Number(
                        ethers.formatUnits(pairAddress[pairAddress.length - 1], selectedBuy?.decimals),
                    ).toFixed(5),
                );
                setToken2valueDirect(pairAddress[pairAddress.length - 1])

            } else {

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(value, selected?.decimals),
                        token1LpBalance,
                        token2LpBalance,
                    ],
                });

                setToken2value(
                    Number(
                        ethers.formatUnits(token0Price, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }
            setSwapType(1);
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPrice2Details = async (value) => {
        try {
            // If value is empty or 0, don't proceed with fetch
            const numValue = parseFloat(value);
            if (!value || value === '' || isNaN(numValue) || numValue === 0 || numValue <= 0) {
                return;
            }

            const routerContract = await getRouterContract(chain);
            if (lpAddress && lpAddress.length > 1) {

                let pairAddress = await readContract({
                    contract: routerContract,
                    method: "function getAmountsIn(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                    params: [ethers.parseUnits(value, selectedBuy?.decimals), lpAddress]
                });

                const requiredToken1Amount = Number(
                    ethers.formatUnits(pairAddress[0], selected?.decimals),
                ).toFixed(5);

                setToken1value(requiredToken1Amount);
                setToken1valueDirect(pairAddress[0]);

                // Check if required amount exceeds balance
                if (token1Details?.balance !== undefined) {
                    setInsufficientBalance(parseFloat(requiredToken1Amount) > token1Details.balance);
                }
            } else {

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(value, selectedBuy?.decimals),
                        token2LpBalance,
                        token1LpBalance,
                    ],
                });

                const requiredToken1Amount = Number(
                    ethers.formatUnits(token0Price, selected?.decimals),
                ).toFixed(5);

                setToken1value(requiredToken1Amount);

                // Check if required amount exceeds balance
                if (token1Details?.balance !== undefined) {
                    setInsufficientBalance(parseFloat(requiredToken1Amount) > token1Details.balance);
                }
            }
            setSwapType(2);
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const handleSwapTokens = () => {
        // Swap the selected tokens
        const tempSelected = selected;
        setSelected(selectedBuy);
        setSelectedBuy(tempSelected);

        // Swap the token details
        const tempDetails = token1Details;
        setToken1Details(token2Details);
        setToken2Details(tempDetails);

        // Swap the values
        const tempValue = token1value;
        setToken1value(token2value);
        setToken2value(tempValue);

        const tempValueDirect = token1valueDirect;
        setToken1valueDirect(token2valueDirect);
        setToken2valueDirect(tempValueDirect);

        // Reset insufficient balance warning
        setInsufficientBalance(false);
    };

    const NATIVE_ADDRESS = "0x0000000000000000000000000000000000000000";
    // Leave enough native balance behind to pay for the swap itself — a literal
    // 100% of a native balance always fails at the gas check.
    const NATIVE_GAS_BUFFER = 0.002;

    /**
     * Set the pay amount to a percentage of the available balance.
     * For the native token, the buffer is subtracted before the split so "Max"
     * still leaves gas.
     */
    const applyBalancePercent = (percent) => {
        const balance = Number(token1Details?.balance ?? 0);
        if (!address || !balance || balance <= 0) return;

        const isNative = token1Details?.address === NATIVE_ADDRESS;
        const spendable = isNative
            ? Math.max(0, balance - NATIVE_GAS_BUFFER)
            : balance;
        if (spendable <= 0) {
            toast.error("Not enough balance to cover network fees");
            return;
        }

        // Floor to the token's precision so we never round above the balance.
        const decimals = Number(token1Details?.decimals ?? 18);
        const raw = (spendable * percent) / 100;
        const factor = 10 ** Math.min(decimals, 8);
        const amount = Math.floor(raw * factor) / factor;
        if (amount <= 0) return;

        setToken1value(amount);
        fetchPriceDetails(amount);
    };

    // Check if token1 needs approval (not native ETH)
    const needsApproval = () => {
        if (!token1Details?.address || !token1value || token1value === 0) return false;
        // Native ETH doesn't need approval
        if (token1Details.address === "0x0000000000000000000000000000000000000000") return false;
        try {
            const requiredAmount = ethers.parseUnits(
                String(token1value),
                token1Details?.decimals,
            );
            return token1Details.approvedBalance < Number(requiredAmount);
        } catch {
            return false;
        }
    };

    const handleApprove = async () => {
        try {
            setLoading(true);
            const contract = getErc20Contract(token1Details.address, chain);
            const transaction = approve({
                contract,
                spender: routerAddress,
                amountWei: ethers.MaxUint256,
            });
            await sendTx({ transaction, account: add });
            toast.success(`${token1Details.symbol} approved!`);

            // Refresh approval balance
            const contract2 = getErc20Contract(token1Details.address, chain);
            const approvedAmount = await allowance({
                contract: contract2,
                owner: address,
                spender: routerAddress,
            });
            setToken1Details((prev) => ({ ...prev, approvedBalance: Number(approvedAmount) }));
            setLoading(false);
        } catch (error) {
            toast.error(error?.message);
            setLoading(false);
        }
    };

    const swapToken = async () => {
        try {
            // Check approval first
            if (needsApproval()) {
                await handleApprove();
                return;
            }

            setLoading(true);
            const contract = getRouterContract(chain);

            let token1amount = ethers.parseUnits(
                String(token1value),
                token1Details?.decimals,
            );

            let token2amount = ethers.parseUnits(
                String(token2value),
                token2Details?.decimals,
            );

            let transaction;
            if (swapType == 1) {
                if (
                    token1Details?.address ==
                    "0x0000000000000000000000000000000000000000" ||
                    token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                ) {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapExactTokensForETH(uint256 amountIn, uint256 amountOutMin, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token1amount,
                            calculateMinOutput(token2value, token2Details?.decimals),
                            lpAddress,
                            // [
                            //     token1Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token1Details?.address,
                            //     token2Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token2Details?.address,
                            // ],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                        value:
                            token1Details?.address ==
                                "0x0000000000000000000000000000000000000000"
                                ? token1amount
                                : 0,
                    });
                } else {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapExactTokensForTokens(uint256 amountIn, uint256 amountOutMin, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token1amount,
                            calculateMinOutput(token2value, token2Details?.decimals),
                            lpAddress,
                            // [token1Details?.address, token2Details?.address],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                    });
                }
            } else {
                if (
                    token1Details?.address ==
                    "0x0000000000000000000000000000000000000000" ||
                    token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                ) {

                    transaction = prepareContractCall({
                        contract,
                        method: "function swapETHForExactTokens(uint256 amountOut, address[] path, address to, uint256 deadline) payable returns (uint256[] amounts)", //"function swapETHForExactTokens(uint256 amountOut, uint256 amountInMax, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token2amount,
                            // "1",
                            lpAddress,

                            // [
                            //     token1Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token1Details?.address,
                            //     token2Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token2Details?.address,
                            // ],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                        value:
                            token1valueDirect,
                    });
                    console.log("%c Line:503 🍅 transaction", "color:#b03734", transaction);

                } else {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapTokensForExactTokens(uint256 amountOut, uint256 amountInMax, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token2amount,
                            calculateMinOutput(token1value, token1Details?.decimals),
                            lpAddress,
                            // [token1Details?.address, token2Details?.address],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                    });
                }
            }
            const txData = await sendTx({ transaction, account: add });
            console.log("%c Line:173 🥐 txData", "color:#3f7cff", txData);
            toast.success("Token Swap Successful!");

            // Reset input values after successful swap
            setToken1value(0);
            setToken2value(0);
            setToken1valueDirect(0);
            setToken2valueDirect(0);

            setLoading(false);
        } catch (error) {
            toast.error(error?.message);
            setLoading(false);
            console.log("%c Line:166 🍕 error", "color:#f5ce50", error);
        }
    };

    return (
        <div className="w-full max-w-[480px] flex flex-col card-3d p-6">
            {/* Card Header */}
            <div className="flex items-center justify-between mb-5">
                <h2 className="text-[22px] font-bold gradient-text">Swap</h2>
                <button
                    className="w-9 h-9 rounded-xl flex items-center justify-center swap-arrow-3d"
                    onClick={() => setSettingsOpen(true)}
                    title="Slippage Settings"
                >
                    <IoSettings className="text-dexora-text-secondary size-[18px]" />
                </button>
            </div>

            {/* Sell Section */}
            <div className="inner-3d p-4 mb-1">
                <div className="flex justify-between items-center mb-3">
                    <span className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest">You Pay</span>
                    {address && (
                        <span className="text-[12px] text-dexora-text-muted">
                            Bal: {balanceLoading ? (
                                <span className="inline-block w-20 h-4 rounded-md bg-dexora-cyan/40 animate-pulse align-middle ml-1" />
                            ) : (
                                <span className="text-dexora-cyan font-semibold">
                                    {token1Details?.balance ? token1Details.balance.toFixed(4) : '0.0000'}
                                </span>
                            )}
                        </span>
                    )}
                </div>
                <div className="flex items-center justify-between gap-3">
                    <input
                        className="text-[28px] sm:text-[32px] font-bold text-dexora-text-primary bg-transparent outline-none w-full placeholder:text-dexora-text-muted/30 disabled:opacity-40"
                        type="number"
                        min="0"
                        step="any"
                        value={token1value === 0 ? '' : token1value}
                        placeholder="0.00"
                        disabled={!address}
                        onChange={(e) => {
                            const value = e.target.value;
                            const numValue = parseFloat(value);
                            if (!value || value === '' || isNaN(numValue) || numValue <= 0) {
                                setToken1value(0);
                                setToken2value(0);
                                setToken2valueDirect(0);
                                setInsufficientBalance(false);
                            } else {
                                setToken1value(value);
                                fetchPriceDetails(value);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                    />
                    <div
                        onClick={() => setOpen(!open)}
                        className="token-pill-3d flex items-center gap-2 px-3 py-2 cursor-pointer shrink-0"
                    >
                        {selected && selected?.symbol ? (
                            <>
                                {selected?.img && (
                                    <img src={selected.img} alt={selected.symbol} className="size-[24px] rounded-full ring-1 ring-white/10" />
                                )}
                                <span className="font-bold text-[15px] text-dexora-text-primary whitespace-nowrap">{selected?.symbol}</span>
                            </>
                        ) : (
                            <span className="font-semibold text-[13px] text-dexora-cyan whitespace-nowrap">Select</span>
                        )}
                        <svg className="w-3.5 h-3.5 text-dexora-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                    </div>
                </div>

                {/* Quick amount selection — mirrors the control already used in
                    RemoveLiquidity so the two screens behave the same. */}
                {address && (
                    <div className="flex justify-between items-center w-full mt-3 gap-2">
                        {[25, 50, 75, 100].map((pct) => {
                            const disabled =
                                balanceLoading || !Number(token1Details?.balance ?? 0);
                            return (
                                <button
                                    key={pct}
                                    type="button"
                                    disabled={disabled}
                                    onClick={() => applyBalancePercent(pct)}
                                    className={`flex-1 text-[12px] font-bold py-2 rounded-xl transition-all ${
                                        disabled
                                            ? "inner-3d text-dexora-text-muted cursor-not-allowed opacity-50"
                                            : "inner-3d text-dexora-text-secondary hover:text-dexora-cyan"
                                    }`}
                                >
                                    {pct === 100 ? "Max" : `${pct}%`}
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* Swap Direction Button */}
            <div className="flex justify-center -my-5 z-10">
                <button
                    onClick={handleSwapTokens}
                    className="swap-arrow-3d w-11 h-11 flex items-center justify-center group"
                >
                    <svg className="w-5 h-5 text-dexora-text-secondary group-hover:text-dexora-cyan transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>
                </button>
            </div>

            {/* Buy Section */}
            <div className="inner-3d p-4 mt-1">
                <div className="flex justify-between items-center mb-3">
                    <span className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest">You Receive</span>
                    {address && (
                        <span className="text-[12px] text-dexora-text-muted">
                            Bal: {balanceLoading ? (
                                <span className="inline-block w-20 h-4 rounded-md bg-dexora-cyan/40 animate-pulse align-middle ml-1" />
                            ) : (
                                <span className="text-dexora-cyan font-semibold">
                                    {token2Details?.balance ? token2Details.balance.toFixed(4) : '0.0000'}
                                </span>
                            )}
                        </span>
                    )}
                </div>
                <div className="flex items-center justify-between gap-3">
                    <input
                        className="text-[28px] sm:text-[32px] font-bold text-dexora-text-primary bg-transparent outline-none w-full placeholder:text-dexora-text-muted/30 disabled:opacity-40"
                        type="number"
                        min="0"
                        step="any"
                        value={token2value === 0 ? '' : token2value}
                        placeholder="0.00"
                        disabled={!address}
                        onChange={(e) => {
                            const value = e.target.value;
                            const numValue = parseFloat(value);
                            if (!value || value === '' || isNaN(numValue) || numValue <= 0) {
                                setToken2value(0);
                                setToken1value(0);
                                setToken1valueDirect(0);
                                setInsufficientBalance(false);
                            } else {
                                setToken2value(value);
                                fetchPrice2Details(value);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                    />
                    <div
                        onClick={() => setOpenBuy(!openBuy)}
                        className="token-pill-3d flex items-center gap-2 px-3 py-2 cursor-pointer shrink-0"
                    >
                        {selectedBuy && selectedBuy?.symbol ? (
                            <>
                                {selectedBuy?.img && (
                                    <img src={selectedBuy.img} alt={selectedBuy.symbol} className="size-[24px] rounded-full ring-1 ring-white/10" />
                                )}
                                <span className="font-bold text-[15px] text-dexora-text-primary whitespace-nowrap">{selectedBuy?.symbol}</span>
                            </>
                        ) : (
                            <span className="font-semibold text-[13px] text-dexora-cyan whitespace-nowrap">Select</span>
                        )}
                        <svg className="w-3.5 h-3.5 text-dexora-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                    </div>
                </div>
            </div>

            {/* Price Info */}
            {(lpAddress || (token1Details.symbol && token2Details.symbol)) && (
                <div className="flex items-center px-1 py-2 mt-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-dexora-cyan/50 mr-2"></div>
                    <span className="text-[12px] text-dexora-text-muted font-medium">
                        {lpAddress ? (
                            <>1 {token1Details.symbol} = {price} {token2Details?.symbol}</>
                        ) : (
                            "Pair not found"
                        )}
                    </span>
                </div>
            )}

            {/* Insufficient Balance Warning */}
            {insufficientBalance && token1value > 0 && (
                <div className="w-full mt-2 p-3 rounded-xl bg-red-500/10 border border-red-500/20" style={{ boxShadow: 'inset 0 2px 4px rgba(255,0,0,0.05)' }}>
                    <p className="text-red-400 text-[13px] font-medium">
                        Insufficient balance. You need {token1value} {selected?.symbol} but only have {token1Details?.balance?.toFixed(4)} {selected?.symbol}
                    </p>
                </div>
            )}

            {/* Swap Button */}
            <button
                className={`mt-5 w-full py-4 text-[16px] font-bold btn-3d ${
                    !address || !lpAddress || insufficientBalance || !token1value || token1value === 0 || !token2value || token2value === 0
                        ? "text-black"
                        : "text-dexora-dark"
                }`}
                onClick={needsApproval() ? handleApprove : swapToken}
                disabled={loading || !address || !lpAddress || insufficientBalance || !token1value || token1value === 0 || !token2value || token2value === 0}
            >
                {loading ? (needsApproval() ? "Approving..." : "Swapping...") : !address ? "Connect Wallet" : insufficientBalance ? "Insufficient Balance" : (!token1value || token1value === 0 || !token2value || token2value === 0) ? "Enter an amount" : needsApproval() ? `Approve ${token1Details?.symbol}` : "Swap"}
            </button>

            <TokenModal open={open} setOpen={setOpen} onClick={setSelected} excludeToken={selectedBuy} />
            <TokenModal open={openBuy} setOpen={setOpenBuy} onClick={setSelectedBuy} excludeToken={selected} />
            <SlippageSettings open={settingsOpen} setOpen={setSettingsOpen} slippage={slippage} setSlippage={setSlippage} />

            {/* Swap Details (when tokens selected and price available) */}
            {lpAddress && token1Details?.symbol && token2Details?.symbol && token1value > 0 && token2value > 0 && (
                <div className="mt-4 inner-3d p-4 space-y-3">
                    <div className="flex items-center justify-between">
                        <span className="text-[12px] text-dexora-text-muted font-medium">Rate</span>
                        <span className="text-[12px] text-dexora-text-primary font-semibold">
                            1 {token1Details.symbol} = {price} {token2Details.symbol}
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-[12px] text-dexora-text-muted font-medium">Slippage Tolerance</span>
                        <span className="text-[12px] text-dexora-cyan font-semibold">{slippage}%</span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-[12px] text-dexora-text-muted font-medium">Minimum Received</span>
                        <span className="text-[12px] text-dexora-text-primary font-semibold">
                            {(parseFloat(token2value) * (1 - slippage / 100)).toFixed(4)} {token2Details.symbol}
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-[12px] text-dexora-text-muted font-medium">Network</span>
                        <span className="text-[12px] text-dexora-text-primary font-semibold">Sepolia Testnet</span>
                    </div>
                </div>
            )}

            {/* Info Section Below Card */}
            <div className="mt-6 space-y-3">
                <div className="grid grid-cols-3 gap-2">
                    {[
                        {
                            icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>,
                            title: "Instant",
                            desc: "Fast swaps"
                        },
                        {
                            icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>,
                            title: "Secure",
                            desc: "Audited contracts"
                        },
                        {
                            icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
                            title: "Low Fees",
                            desc: "0.3% per swap"
                        },
                    ].map((item, i) => (
                        <div key={i} className="pool-card-3d p-3 flex flex-col items-center text-center gap-1.5">
                            <div className="text-dexora-cyan">{item.icon}</div>
                            <span className="text-[11px] font-bold text-dexora-text-primary">{item.title}</span>
                            <span className="text-[10px] text-dexora-text-muted">{item.desc}</span>
                        </div>
                    ))}
                </div>

                {/* How Swapping Works */}
                <div className="pt-3 border-t border-dexora-dark-tertiary/20">
                    <p className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest mb-3">How it works</p>
                    <div className="space-y-2">
                        {[
                            { step: "1", title: "Select tokens", desc: "Choose the token you want to pay with and the token you want to receive" },
                            { step: "2", title: "Enter amount", desc: "Type the amount — the exchange rate is calculated automatically from the liquidity pool" },
                            { step: "3", title: "Confirm swap", desc: "Approve (first time) and confirm the swap. Tokens arrive in your wallet instantly" },
                        ].map((item, i) => (
                            <div key={i} className="pool-card-3d p-3 flex items-start gap-3">
                                <div className="w-6 h-6 rounded-md flex items-center justify-center bg-dexora-cyan/10 text-dexora-cyan text-[11px] font-bold shrink-0 mt-0.5">
                                    {item.step}
                                </div>
                                <div>
                                    <p className="text-[12px] font-bold text-dexora-text-primary">{item.title}</p>
                                    <p className="text-[11px] text-dexora-text-muted leading-relaxed">{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Open Token Listing CTA */}
                <div className="pool-card-3d p-4 flex items-center gap-3">
                    <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-dexora-cyan/10 text-dexora-cyan shrink-0">
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-[12px] font-bold text-dexora-text-primary">List any token instantly</p>
                        <p className="text-[11px] text-dexora-text-muted">No approval needed — add liquidity to make your token tradable on Dexora DEX</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Swap;
